<template>
  <div>
    <div v-if="answer">
      <div
        style="display: inline-block; border-right: 24px solid transparent; width: 0; height: 0;"
        :style="{ borderBottom: `13px solid ${borderColor}` }"
      ></div>
    </div>
    <div
      style=" border-top: 4px solid; border-right: 1px solid; border-bottom: 1px solid; border-left: 1px solid;border-radius: 8px; padding: 16px; text-align: left;"
      :style="{ borderColor: borderColor, backgroundColor: bgColor }"
    >
      <table width="100%" style="border-collapse: collapse;">
        <tr>
          <td align="left" style=" font-size: 16px;font-weight: bold;">
            {{ review.name }}
          </td>
          <td align="right" style="font-size: 12px;" v-if="review.date">
            {{ review.date }}
          </td>
        </tr>
      </table>

      <div
        style=" margin-top: 8px;background-image: url('https://gatoreviews-emails.s3.eu-west-3.amazonaws.com/generic/icon-star-empty.png'); background-repeat: repeat-x; background-size: 24px auto; width: 120px; text-align: left;"
        v-if="review.rating"
      >
        <div
          style="background-image: url('https://gatoreviews-emails.s3.eu-west-3.amazonaws.com/generic/icon-star-full.png'); background-repeat: repeat-x; background-size: 24px auto; height: 24px;"
          :style="{ width: `${review.rating * 20}%` }"
        ></div>
      </div>

      <div style="margin-top: 8px; text-align: left;">
        {{ review.comment }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExternalReview',
  props: {
    review: {
      type: Object,
      require: true,
    },
    borderColor: {
      type: String,
      default: '#00A74B',
    },
    bgColor: {
      type: String,
      default: '#F5F6F9',
    },
    answer: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
